import jwtDecode from 'jwt-decode'
export const decodeToken = (token) => {
  let decodedToken = null
  if (!token) {
    return decodedToken
  }
  try {
    decodedToken = jwtDecode(token)
  } catch (exception) {
    throw new Error(`JWT Token cannot be decoded.  Message: ${exception}`)
  }
  return decodedToken
}



// WEBPACK FOOTER //
// ./src/tools/oidc.js